import React from 'react';
import { Link } from 'react-router-dom';
import BlogPostPreview from './BlogPostPreview';
import BlogSectionSkeleton from './BlogSectionSkeleton';
import { BlogPostPreview as BlogPostPreviewType } from '../../types/blog';

interface BlogSectionProps {
  posts: BlogPostPreviewType[];
  isLoading: boolean;
  error?: string | null;
}

const BlogSection: React.FC<BlogSectionProps> = ({ posts, isLoading, error }) => {
  // Show skeleton while loading
  if (isLoading) {
    return <BlogSectionSkeleton />;
  }

  // Hide section on error (silent fail)
  if (error) {
    console.error('Blog section error:', error);
    return null;
  }

  // Hide section if no posts
  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold text-gray-900">Latest from NACME</h2>
        <Link 
          to="/blog" 
          className="text-sm text-blue-600 hover:text-blue-800 transition-colors"
        >
          View all posts →
        </Link>
      </div>
      
      <div className="space-y-3">
        {posts.map(post => (
          <BlogPostPreview key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};

export default BlogSection;